import {Component, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-corners-layout",
    imports: [],
    templateUrl: "./corners-layout.component.html",
    styleUrl: "./corners-layout.component.scss",
})
export class CornersLayoutComponent {}
